import React from "react";
import { Link } from "react-router-dom";
import { FaFacebook, FaTwitter, FaInstagram, FaLinkedin } from "react-icons/fa";
import { MdEmail, MdPhone, MdLocationOn } from "react-icons/md";

const Footer = () => {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          {/* Logo and About Section */}
          <div className="footer-section">
            <div className="logo-container">
              <img
                src="/images/logo.png"
                alt="Topup Connect Logo"
                className="footer-logo"
              />
            </div>
            <p className="about-text">
              Your trusted partner for mobile recharge, bill payments, and
              digital services. We provide fast, secure, and reliable
              transactions with excellent customer support.
            </p>
            <div className="social-icons">
              <a
                href="https://facebook.com"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FaFacebook className="icon" />
              </a>
              <a
                href="https://twitter.com"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FaTwitter className="icon" />
              </a>
              <a
                href="https://instagram.com"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FaInstagram className="icon" />
              </a>
              <a
                href="https://linkedin.com"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FaLinkedin className="icon" />
              </a>
            </div>
          </div>

          {/* Quick Links Section */}
          <div className="footer-section">
            <h3>Quick Links</h3>
            <ul>
              <li>
                <Link to="/home">Home</Link>
              </li>
              <li>
                <Link to="/about-us">About Us</Link>
              </li>
              <li>
                <Link to="/services">Services</Link>
              </li>
              <li>
                <Link to="/contact-us">Contact</Link>
              </li>
            </ul>
          </div>

          {/* Legal Links Section */}
          <div className="footer-section">
            <h3>Legal</h3>
            <ul>
              <li>
                <Link to="/privacy-policy">Privacy Policy</Link>
              </li>
              <li>
                <Link to="/refund-policy">Refund Policy</Link>
              </li>
              <li>
                <Link to="/terms-conditions">Terms & Conditions</Link>
              </li>
            </ul>
          </div>

          {/* Contact Information Section */}
          <div className="footer-section contact-section">
            <h3>Contact Us</h3>
            <ul className="contact-info">
              <li className="contact-item">
                <MdLocationOn className="contact-icon location-icon" />
                <span className="contact-text">
                  Barasat - 1, Kathuria, Malikapur, Duttapukur, Barasat, North
                  24 Parganas, West Bengal - 700126
                </span>
              </li>
              <li className="contact-item">
                <MdPhone className="contact-icon" />
                <a href="tel:+917890067005" className="contact-text">
                  +91 7890067005
                </a>
              </li>
              <li className="contact-item">
                <MdEmail className="contact-icon" />
                <a
                  href="mailto:support@topupconnect.in"
                  className="contact-text"
                >
                  support@topupconnect.in
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="footer-bottom">
          <p>
            &copy; {new Date().getFullYear()} Topup Connect. All Rights
            Reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
